import React from 'react';
import { motion } from 'framer-motion';
import { HeroSection } from './components/HeroSection';
import { NarrativeSection } from './components/NarrativeSection';
import { FeaturesSection } from './components/FeaturesSection';
import { GallerySection } from './components/GallerySection';
import { HeritageSection } from './components/HeritageSection';
import { AgentSection } from './components/AgentSection';
import { DecorativeDivider } from './components/DecorativeDivider';
function StonebridgeHeader() {
  return <header className="sticky top-0 z-50 w-full bg-dark/95 backdrop-blur-sm border-b border-white/5" data-id="element-0">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4" data-id="element-1">
        {/* Wordmark */}
        <a href="#" className="flex items-center gap-2" aria-label="Stonebridge home" data-id="element-2">
          <img src="https://cdn.magicpatterns.com/uploads/neNaCNBs6EW2ecQoy3yAp9/Stonebridge_logo_master_reversed_1.0.png" alt="Stonebridge Property Group" className="h-7 w-auto" data-id="element-3" />
        </a>

        {/* CTA Button */}
        <a href="#contact" className="hidden md:inline-block rounded-full border border-white/20 px-6 py-2 font-heading text-xs font-bold uppercase tracking-widest text-white transition-colors duration-200 hover:bg-white hover:text-dark" data-id="element-4">
          Enquire
        </a>
      </div>
    </header>;
}
export function App() {
  return <div className="w-full min-h-screen bg-dark" data-id="element-5">
      <StonebridgeHeader data-id="element-6" />
      <main data-id="element-7">
        <HeroSection data-id="element-8" />
        <DecorativeDivider variant="ornate" onDark data-id="element-9" />
        <NarrativeSection data-id="element-10" />
        <DecorativeDivider variant="simple" onDark={false} data-id="element-11" />
        <FeaturesSection data-id="element-12" />
        <DecorativeDivider variant="ornate" onDark data-id="element-13" />
        <GallerySection data-id="element-14" />
        <DecorativeDivider variant="simple" onDark data-id="element-15" />
        <HeritageSection data-id="element-16" />
        <DecorativeDivider variant="simple" onDark={false} data-id="element-17" />
        <AgentSection data-id="element-18" />
      </main>
    </div>;
}